"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cookies = require("@kiwicom/cookies");
var cookies = _interopRequireWildcard(require("../cookies"));
var local = _interopRequireWildcard(require("../local"));
var _local2 = require("../../../consts/local");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const handleAffiliateId = (fromUrl, rest) => {
  // This is ridiculous, but was implemented as R.map(String, rest) in Ramda, so kept it
  const params = Object.fromEntries(Object.entries(rest).map(_ref => {
    let [key, val] = _ref;
    return [key, String(val)];
  }));

  // URL 1st
  if (fromUrl) {
    cookies.save(_cookies.Cookie.AFFILIATE_ID, fromUrl, {
      expires: 30
    });
    local.save(_local2.AFFILIATE_PARAMS, JSON.stringify(params));
    return {
      id: fromUrl,
      params
    };
  }

  // Cookies / localStorage 2nd
  const fromCookies = cookies.load(_cookies.Cookie.AFFILIATE_ID);
  if (fromCookies) {
    const loadedParams = local.load(_local2.AFFILIATE_PARAMS);
    return {
      id: fromCookies,
      params: loadedParams ? JSON.parse(loadedParams) : {}
    };
  }
  local.remove(_local2.AFFILIATE_PARAMS);
  return null;
};
var _default = exports.default = handleAffiliateId;